import { expirationDate, number } from 'card-validator';

interface IParseCardExpirationDateReturn {
  month: string;
  year: string;
}

export const parseCardExpirationDate = (date: string): IParseCardExpirationDateReturn => {
  if (!date) return { month: '', year: '' };
  const { month, year, isPotentiallyValid } = expirationDate(date);
  if (isPotentiallyValid) {
    return { month: month ?? '', year: year ?? '' };
  }
  const [parsedMonth, parsedYear] = date.split('/');
  return { month: parsedMonth, year: parsedYear };
};

export const getCreditCardInfo = (cardNumber: string) => {
  const processedCardNumber = cardNumber.replace(/\s/g, '');
  const validation = number(processedCardNumber);
  return {
    paymentSystem: validation.card?.type,
    isValid: validation.isValid,
    isPotentiallyValid: validation.isPotentiallyValid,
    lastDigits: processedCardNumber.substring(processedCardNumber.length - 4),
  };
};

export const getCardType = (cardNumber: string) : string | null => {
  const numberValidation = number(cardNumber);
  if (!numberValidation.card) {
    return null;
  }
  return numberValidation.card.type;
};
